<template>
    <el-container direction="vertical" v-loading="loading">
        <el-row>
            <el-col :span="2">
                <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
        </el-row>
        <el-row class="row" v-for="tax in taxes" :key="tax.id">
            <el-col :span="1">{{tax.code}}</el-col>
            <tax-input :taxType="'hst'" :tax="tax.hstTax" @update="taxUpdated(tax.id, $event)" v-if="tax.hstTax"></tax-input>
            <tax-input :taxType="'gst'" :tax="tax.gstTax" @update="taxUpdated(tax.id, $event)" v-if="tax.gstTax"></tax-input>
            <tax-input :taxType="'qst'" :tax="tax.qstTax" @update="taxUpdated(tax.id, $event)" v-if="tax.qstTax"></tax-input>
        </el-row>
    </el-container>
</template>

<script>
    import api from '../api'
    import TaxInput from './TaxInput'
    export default {
        name: 'canadian-tax-list',
        data() {
            return {
                loading: false,
                dialogVisible: false,
                taxes: []
            }
        },
        methods: {
            download() {
                api.download(this.filter);
            },
            taxUpdated: (taxId, value) => {
                this.loading = true
                api.updateTaxForState(taxId, value).then(() => this.loading = false);
            }
        },
        mounted() {
            this.loading = true
            api.getTaxes().then(response => {
                this.loading = false
                this.taxes = response.data
            })
        },
        components: {
            TaxInput
        }
    }
</script>

<style scoped>
    .row {
        margin: 5px 0;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/masters/canadiantaxes/components/CanadianTaxList.vue